import Benefits from "../../Container/Benefits/Benefits";
import Question from "../../Container/Question/Question";
import HomeAbout from "../../Container/homeAbout/HomeAbout";
import HomeSpeakers from "../../Container/homeSpeakers/HomeSpeakers";
import Hero from "../../components/Hero/Hero";
import SponsorLogo1 from "../../assets/images/sponsors/OZORE.png";
import SponsorLogo2 from "../../assets/images/sponsors/Scrap Art Museum.png";
import SponsorLogo3 from "../../assets/images/sponsors/elior.png";
import SponsorLogo4 from "../../assets/images/sponsors/uac-FOODS.png";
import "./Home.scss";

const HomePage = () => {
  return (
    <>
      {/* TODO: I STILL WANT TO ADD EVENT SCHEDULE SECTION TO THIS PAGE    */}
      {/* TODO: I STILL WANT TO ADD EVENT SCHEDULE SECTION TO THIS PAGE    */}
      {/* TODO: I STILL WANT TO ADD EVENT SCHEDULE SECTION TO THIS PAGE    */}
      <Hero />
      <HomeAbout />
      <HomeSpeakers />
      <Benefits />
      <Question />
      <div
        className="sponsor__container-logos flex"
        style={{ paddingBottom: "5rem" }}
      >
        <div className="logos_title">
          <h1>Our Sponsors</h1>
        </div>

        <div className="logos">
          <img src={SponsorLogo1} alt="sponsor-logo" />
          <img src={SponsorLogo2} alt="sponsor-logo" />
          <img src={SponsorLogo3} alt="sponsor-logo" />
          <img src={SponsorLogo4} alt="sponsor-logo" />
        </div>
      </div>
    </>
  );
};

export default HomePage;
